import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import _concat from 'lodash/concat';

import filterReconFields from 'constants/filterReconFields';

import initialState from './initialState';
import actionTypes from './actionTypes';

const reportConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REPORTS_BY_RECON_SUCCESS:
            return {
                ...state,
                reportsByRecons: action.payload,
            };
        case actionTypes.GET_REPORT_FIELD_MAPPING_SUCCESS: {
            const { unMappedReconFields = [] } = action.payload;
            let clonedMappedDict;
            clonedMappedDict = _cloneDeep(unMappedReconFields);
            filterReconFields.map((field) => {
                clonedMappedDict.push({
                    field_name: field.name,
                    value: field.label,
                    field_type: field.type,
                });
            });
            return {
                ...state,
                reportFieldMappings: action.payload,
                clonedMappedDict,
            };
        }
        case actionTypes.RESET_REPORT_FIELD_MAPPING_SUCCESS: {
            return {
                ...state,
                reportFieldMappings: [],
                clonedMappedDict: [],
            };
        }
        case actionTypes.GET_REPORT_RECON_FIELD_EXPRESSION:
            return {
                ...state,
                reportReconFieldExpressions: action.payload,
            };
        case actionTypes.GET_REPORT_RECON_MAPPINGS:
            return {
                ...state,
                reportReconFieldMaps: action.payload,
            };

        case actionTypes.GET_NEW_REPORT_FIELD_MAPPING_SUCCESS:
            return {
                ...state,
                reportFieldMappings: {
                    mappedDataDictionary: _get(action.payload, 'mappedDataDictionary', []),
                    unMappedDataDictionary: [],
                    reconFieldMappings: _get(action.payload, 'reconFieldMappings', []),
                },
                reconFieldColumnNames: _cloneDeep(_concat(_get(action.payload, 'reconFieldMappings', []), filterReconFields)),
            };
        case actionTypes.GET_REPORT_SETTINGS:
            return {
                ...state,
                reportFieldSettings: action.payload,
            };
        case actionTypes.GET_REPORT_WORKFLOW:
            return {
                ...state,
                reportDataFromWorkflow: action.payload,
            };
        case actionTypes.GET_REPORT_CUSTOM_QUERY:
            return {
                ...state,
                reportCustomQueryResults: action.payload,
            };
        default:
            return state;
    }
};

export default reportConfigurationReducer;
